import { useAddCartItem } from "./cart/cart.mjs";
import { useProductContext } from "./productContext.mjs";
import { useBundleProductContext } from "./productBundle.mjs";
import { ref, watch } from "vue";
export function useAddProductToCartContext(_useAddCartItem = useAddCartItem, _useProductContext = useProductContext, _useBundleProductContext = useBundleProductContext) {
  const { addItem, addConfigurableProductItem } = _useAddCartItem();
  const { productCtx, product } = _useProductContext();
  const { selectedBundleOptions } = _useBundleProductContext();
  const quantity = ref(1);
  watch(product, (newProduct) => {
    quantity.value = newProduct?.cartControl?.min || 1;
  });
  async function addToCart() {
    if (product.value?.type === "GroupedProduct" && product.value.groupItems) {
      await addItem(
        product.value.groupItems.map((i) => {
          return {
            sku: i.sku,
            quantity: i.qty
          };
        })
      );
      return;
    }
    if (product.value?.type === "BundleProduct" && product.value.bundleItems) {
      await addItem({
        sku: product.value.sku,
        quantity: quantity.value,
        selected_options: selectedBundleOptions.value
      });
      return;
    }
    if (productCtx.value?.type === "ConfigurableProduct") {
      if (product.value?.parentSku) {
        await addConfigurableProductItem({
          data: {
            sku: product.value.sku,
            quantity: quantity.value,
            selected_options: selectedBundleOptions.value,
            parent_sku: product.value?.parentSku || ""
          },
          parent_sku: product.value?.parentSku || ""
        });
        return;
      }
      throw new Error("requiredConfigurationOption");
    }
    await addItem({
      sku: product.value?.sku,
      parent_sku: product.value?.parentSku || "",
      quantity: quantity.value
    });
  }
  return {
    addToCart,
    quantity
  };
}
